import { atom } from 'jotai';

export type SidebarAtom = {
  visible: boolean;
};

export const sidebarAtom = atom<SidebarAtom>({
  visible: false,
});
